export default "__VITE_ASSET__f5174adb__"